var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.is_cancelled===1)?_c('v-icon',{staticClass:"ma-0 pa-0",attrs:{"left":""}},[_vm._v("mdi-cancel")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }